import axiosClient from './axiosClient';

// type user
const unitCourseApi = {
  getUnit: (params) => {
    const url = '/user-courses/get-unit';
    return axiosClient.get(url, { params });
  },
  getUnits: (params) => {
    const url = '/user-courses/get-units';
    return axiosClient.get(url, { params });
  },
  setCompleteUnit: (data, unitId) => {
    const url = `/user-courses/user-complete-unit?id=${unitId}`;
    return axiosClient.post(url, data);
  },
  resetUnit: (unitId) => {
    const url = `/user-courses/reset-unit-result?id=${unitId}`;
    return axiosClient.post(url);
  },
  getDataStartTest: (params, data) => {
    const url =
      `/user-courses/start-unit-question?` + new URLSearchParams(params);
    return axiosClient.post(url, data);
  },
  updateQuestion: (params, data) => {
    const url =
      `/user-courses/update-unit-question?` + new URLSearchParams(params);
    return axiosClient.post(url, data);
  },
  submitUnitQuestion: (params, data) => {
    const url = '/user-courses/submit-unit-question';
    return axiosClient.post(url, data, { params });
  },
  getDataStartSurvey: (params, data) => {
    const url = '/user-courses/start-unit-survey';
    return axiosClient.post(url, data, { params });
  },
  submitUnitSurvey: (params, data) => {
    const url = '/user-courses/submit-unit-survey';
    return axiosClient.post(url, data, { params });
  },
  trackUserCourseTest: (unitId, timer) => {
    const url = `/user-courses/track-user-course-unit?id=${unitId}&timer=${timer}`;
    return axiosClient.get(url);
  },
  getAllQuestion: (id) => {
    const url = `/user-courses/get-unit-questions?id=${id}`;
    return axiosClient.get(url);
  },
  updateUnitBookmark: (params, data) => {
    const url = `/user-courses/unit-bookmark?` + new URLSearchParams(params);
    return axiosClient.put(url, data);
  },
  postScreenshot: (params, data) => {
    const url =
      `/user-courses/store-test-screenShot?` + new URLSearchParams(params);
    return axiosClient.post(url, data);
  },
  assignmentReview: (data) => {
    const url = '/user-courses/assignment-review';
    return axiosClient.post(url, data);
  },
};

export default unitCourseApi;
